export default "__VITE_ASSET__DtWOjJCJ__"